import "./App.css";
import { Wallet } from "./Wallet";
import Creator from "./Creator";
import { Toaster } from "react-hot-toast";

function Home() {
  return (
    <div className="app">
      <div className="container">
        <h2
          style={{
            marginTop: 0,
            color: "#454f5b",
            fontFamily: "font-family: Public Sans,sans-serif",
          }}
        >
          Discord Sender
        </h2>
        <Wallet>
          <Creator />
        </Wallet>
        <Toaster />
      </div>
    </div>
  );
}

export default Home;
